<template>
  <div class="page">
    <Frame :loading="loading" :finished="finished">
      <template v-slot:header>
        <div class="header">
          <div class="clear" @click="oneClickReadEvt">
            <span class="icon">
              <van-icon
                size="20px"
                color="#333"
                :name="require('@/assets/image/common/clear.png')"
              />
            </span>
            <span class="text">清除未读</span>
          </div>
          <div class="filter">
            <van-icon
              size="24px"
              :name="require('@/assets/image/common/filter.png')"
              @click="showDialog"
            />
          </div>
        </div>
      </template>
      <template v-slot:body>
        <div class="body-wrapp">
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
              v-model:loading="loading"
              :finished="finished"
              :finished-text="
                finished && msgList.length >= total && msgList.length > 0
                  ? '--没有更多了--'
                  : ''
              "
              @load="onLoad"
            >
              <MsgItem
                :detail="item"
                :key="item.id"
                v-for="item in msgList"
                @navigate="navigateDetail(item)"
              />
              <van-empty
                v-if="msgList.length <= 0 && finished"
                class="custom-image"
                :image="require('@/assets/image/no-data.png')"
                description="暂无数据"
              />
            </van-list>
          </van-pull-refresh>
        </div>
        <FilterDialog
          v-if="isShowDialog"
          title="筛选"
          @right="dialogCancleEvt"
          @ok="dialogOkEvt"
          @reset="dialogResetEvt"
        >
          <FilterStatusList
            ref="filterStatusRef"
            :default-ids="moduleTypeList"
            :list="filterList"
          />
        </FilterDialog>
      </template>
    </Frame>
  </div>
</template>

<script>
import Frame from "@/components/frame.vue";
import MsgItem from "./components/msgItem.vue";
import FilterDialog from "@/components/filterDialog.vue";
import FilterStatusList from "@/components/filterStatusList.vue";
import { Toast } from "vant";
import { ref, computed, watch } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
export default {
  name: "msgCenter",
  components: {
    Frame,
    MsgItem,
    FilterDialog,
    FilterStatusList,
  },
  setup() {
    const route = useRoute();
    document.title = route.meta.title;

    const store = useStore();

    const filterStatusRef = ref(null);
    const moduleTypeList = ref([]);

    const isShowDialog = ref(false);
    const showDialog = () => {
      isShowDialog.value = true;
    };
    const dialogCancleEvt = () => {
      isShowDialog.value = false;
    };
    const dialogOkEvt = () => {
      moduleTypeList.value = filterStatusRef.value.activeIds;
      msgList.value = [];
      pageIndex = 1;
      getMessageList();
      isShowDialog.value = false;
    };
    const dialogResetEvt = () => {
      filterStatusRef.value.resetEvt();
    };

    // 筛选列表
    const filterList = ref([]);
    const messageModuleList = (params) =>
      store.dispatch("msgCenter/messageModuleList", params);
    const getFilterList = async () => {
      let r = await messageModuleList();
      if (r.message === "success") {
        let list = r.data.list;
        list.map((item) => {
          let temp = {
            name: item.moduleName,
            value: item.moduleCode,
          };
          filterList.value.push(temp);
        });
      } else {
        Toast.fail(r.message);
      }
    };

    getFilterList();

    // 消息列表
    let pageIndex = 1;
    let pageSize = 30;
    const msgList = ref([]);
    const loading = ref(false);
    const finished = ref(false);
    const refreshing = ref(false);
    const total = ref(0);

    const onLoad = () => {
      getMessageList();
    };

    const onRefresh = () => {
      // 清空列表数据
      msgList.value = [];
      pageIndex = 1;
      finished.value = false;
    };

    const messageList = (params) =>
      store.dispatch("msgCenter/messageList", params);
    const getMessageList = async () => {
      let params = {
        moduleTypeList: moduleTypeList.value,
        pageNo: pageIndex,
        pageSize: pageSize,
      };
      setTimeout(() => {
        loading.value = false;
        finished.value = true;
      }, 3000);
      let r = await messageList(params);
      if (r.message == "success") {
        if (refreshing.value) {
          msgList.value = [];
          refreshing.value = false;
        }
        msgList.value.push(...r.data.list);
        total.value = r.data.total;
        loading.value = false;
        pageIndex++;
        if (msgList.value.length >= r.data.total) {
          finished.value = true;
        }
      } else {
        refreshing.value = false;
        finished.value = true;
        loading.value = false;
        Toast.fail(r.message);
      }
    };

    // 小程序返回刷新
    const freshTimestamp = computed(() => store.state.freshTimestamp);
    watch(
      freshTimestamp,
      (newTime) => {
        if (newTime) {
          msgList.value = [];
          pageIndex = 1;
          getMessageList();
        }
      },
      {
        immediate: true,
      }
    );

    // 一键清除
    const oneClickRead = (params) =>
      store.dispatch("msgCenter/oneClickRead", params);
    const oneClickReadEvt = async () => {
      let r = await oneClickRead();
      if (r.message == "success") {
        pageIndex = 1;
        msgList.value = [];
        getMessageList();
      } else {
        Toast.fail(r.message);
      }
    };

    const navigateDetail = (item) => {
      let { moduleName, appUrl } = item;
      console.log("item",item)
      if (appUrl) {
        /* eslint-disable */
        uni.navigateTo({
          url: appUrl.indexOf("/") !== 0 ? `/${appUrl}` : appUrl,
        });
				dd.navigateTo({url: '/' + appUrl }) 
        /* eslint-disable */
      } else {
        Toast.fail(`${moduleName}缺少跳转地址，请联系管理员添加！`);
      }
    };

    return {
      filterStatusRef,
      isShowDialog,
      showDialog,
      dialogCancleEvt,
      dialogOkEvt,
      dialogResetEvt,
      msgList,
      moduleTypeList,
      filterList,
      getFilterList,
      getMessageList,
      oneClickReadEvt,
      onLoad,
      onRefresh,
      loading,
      finished,
      total,
      refreshing,
      navigateDetail,
    };
  },
};
</script>

<style lang="less" scoped>
.page {
  height: 100vh;
}
.header {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 44px;
  padding: 0 15px;
  background-color: #fff;
  .clear {
    display: flex;
    align-items: center;
    height: 100%;
    .icon {
      display: flex;
      align-items: center;
      margin-right: 2px;
    }
  }
}
.list {
  height: 100%;
}
</style>
